import actions from './actions';

const initState = {
  loadingInitData: false,
  view: 'gridView',
  viewTopbarCart: false,
  productQuantity: [],
  productosVenta: [],
  cliente: {},
  ventas: [],
  paginationInfo: {},
  ventaState: {
    loading: false,
    error: null,
    success: null,
  },
};
export default (state = initState, action) => {
  switch (action.type) {
    case actions.INIT_DATA:
      return {
        ...state,
        loadingInitData: true,
        productQuantity: action.payload.productQuantity,
        productosVenta: action.payload.productosVenta,
      };
    case actions.SET_CLIENTE:
      return {
        ...state,
        cliente: action.data
      }
    case actions.CHANGE_VIEW:
      return {
        ...state,
        view: action.view,
      };
    case actions.VIEW_TOPBAR_CART:
      return {
        ...state,
        viewTopbarCart: action.viewTopbarCart,
      };
    case actions.SET_VENTA:
      return {
        ...state,
        ventaState: {
          loading: true,
          error: null,
          success: null,
        },
      }
    case actions.RESET_VENTA:
      return {
        ...state,
        productosVenta: [],
        cliente: {},
        ventaState: {
          loading: false,
          error: action.error || null,
          success: action.success || null,
        },
      };
    case actions.UPDATE_SPECIFIC_VENTA: {
      let newVentas = state.ventas.map(item => {
        if (item._id === action.doc._id) {
          return action.doc
        }
        return item;
      })

      if (action.doc.actualizar) {
        newVentas = newVentas.filter(item => item._id !== action.doc._id)
      }

      return {
        ...state,
        ventas: newVentas
      }
    }
    case actions.DELETE_SPECIFIC_VENTA: {
      const newVentas = state.ventas.filter(item => item._id !== action.id)
      return {
        ...state,
        ventas: newVentas
      }
    }
    case actions.GET_VENTAS:
      return {
        ...state,
        loadingInitData: true,
      }
    case actions.FORMATEAR_VENTAS:
      return {
        ...state,
        ventas: action.payload,
        loadingInitData: false,
      }
    case actions.UPDATE_DATA:
      return {
        ...state,
        productosVenta: action.products,
      };
    case actions.SET_PAGINATION_INFO:
      return {
        ...state,
        paginationInfo: action.payload,
      };
    default:
      return state;
  }
};
